// extracted by mini-css-extract-plugin
module.exports = {"SimpleSearchContainer":"DealSearch_SimpleSearchContainer__GAziy","SearchDetailContainer":"DealSearch_SearchDetailContainer__26_OB"};